"use strict";

module.exports = {
  BRAINTREE_VERSION: "2018-05-10",
};
